// @flow
import { Box } from '@mui/material'
import React from 'react'
import Autocompletes from "./autocompletes";
import Checkboxes from "./checkboxes";
import DateTimePickers from "./dateTimePickers";
import RadioButtons from "./radioButtons";
import Ratings from "./ratings";
import Selects from "./selects";
import Sliders from "./sliders";
import Switches from "./switches";
import TextFields from "./textFields";
import ToggleButtons from "./toggleButtons";

/*type Props = {};*/

const top100Films = [
	{label: 'The Shawshank Redemption', year: 1994},
	{label: 'The Godfather', year: 1972},
	{label: 'The Godfather: Part II', year: 1974},
	{label: 'The Dark Knight', year: 2008},
	{label: '12 Angry Men', year: 1957},
	{label: "Schindler's List", year: 1993},
	{label: 'Pulp Fiction', year: 1994},
	{label: 'The Lord of the Rings: The Return of the King', year: 2003},
	{label: 'The Good, the Bad and the Ugly', year: 1966},
	{label: 'Fight Club', year: 1999},
	{label: 'The Lord of the Rings: The Fellowship of the Ring', year: 2001},
	{label: 'Forrest Gump', year: 1994},
	{label: 'Inception', year: 2010},
	{label: "One Flew Over the Cuckoo's Nest", year: 1975},
	{label: 'Goodfellas', year: 1990},
	{label: 'The Matrix', year: 1999},
	{label: 'Seven Samurai', year: 1954},
	{label: 'City of God', year: 2002},
	{label: 'Se7en', year: 1995},
	{label: 'The Silence of the Lambs', year: 1991},
	{label: "It's a Wonderful Life", year: 1946},
	{label: 'Life Is Beautiful', year: 1997},
	{label: 'The Usual Suspects', year: 1995},
	{label: 'Léon: The Professional', year: 1994},
	{label: 'Spirited Away', year: 2001},
	{label: 'Saving Private Ryan', year: 1998},
	{label: 'Once Upon a Time in the West', year: 1968},
	{label: 'American History X', year: 1998},
	{label: 'Interstellar', year: 2014},
	{label: 'Casablanca', year: 1942},
	{label: 'City Lights', year: 1931},
	{label: 'Psycho', year: 1960},
]

const Inputs = (/*props: Props*/) => {
	const [showPassword, setShowPassword] = React.useState(false)
	const [age, setAge] = React.useState('');
	const [state, setState] = React.useState({
		gilad: true,
		jason: false,
		antoine: false,
	});
	const [alignment, setAlignment] = React.useState('left');
	const label = {inputProps: {'aria-label': 'Switch demo'}};
	const defaultProps = {
		options: top100Films,
		getOptionLabel: (option) => option.label,
	};
	const flatProps = {
		options: top100Films.map((option) => option.label),
	};
	const {gilad, jason, antoine} = state;
	const error = [gilad, jason, antoine].filter((v) => v).length !== 2;
	/*const currencies = [
		{value: 'USD', label: '$',},
		{value: 'EUR', label: '€',},
		{value: 'BTC', label: '฿',},
		{value: 'JPY', label: '¥',},
	]*/
	const handleAgeChange = (event) => {
		setAge(event.target.value);
	};
	const handleChange = (event) => {
		setState({
			...state,
			[event.target.name]: event.target.checked,
		});
	};
	const handleAlignment = (event, newAlignment) => {
		setAlignment(newAlignment);
	};
	const handleClickShowPassword = () => setShowPassword((show) => !show)
	const handleMouseDownPassword = (event) => {
		event.preventDefault()
	}
	
	return (
		<div>
			<>TODO::ΠΡΟΣΘΗΚΗ ΔΙΚΩΝ ΜΑΣ ΠΑΡΑΔΕΙΓΜΑΤΩΝ ΜΕ ΤΑ COMPONENT MAS/</>
			<h3>
				SELECT -----------------------------------------------------------------------------
			</h3>
			<Selects age={age} handleAgeChange={handleAgeChange}/>
			{/*TODO::OTHER SELECT FIELDS*/}
			{/*<Box
				component="form"
				noValidate
				autoComplete="off"
			>
				<Grid container spacing={3}>
					<Grid item>
						
						<TextField
							id="outlined-select-currency"
							select
							label="Select"
							defaultValue="EUR"
							helperText="Please select your currency"
						>
							{currencies.map((option) => (
								<MenuItem
									key={option.value}
									value={option.value}
								>
									{option.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item>
						<TextField
							id="outlined-select-currency-native"
							select
							label="Native select"
							defaultValue="EUR"
							SelectProps={{
								native: true,
							}}
							helperText="Please select your currency"
						>
							{currencies.map((option) => (
								<option
									key={option.value}
									value={option.value}
								>
									{option.label}
								</option>
							))}
						</TextField>
					</Grid>
					<Grid item>
						
						<TextField
							id="filled-select-currency"
							select
							label="Select"
							defaultValue="EUR"
							helperText="Please select your currency"
							variant="filled"
						>
							{currencies.map((option) => (
								<MenuItem
									key={option.value}
									value={option.value}
								>
									{option.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item>
						<TextField
							id="filled-select-currency-native"
							select
							label="Native select"
							defaultValue="EUR"
							SelectProps={{
								native: true,
							}}
							helperText="Please select your currency"
							variant="filled"
						>
							{currencies.map((option) => (
								<option
									key={option.value}
									value={option.value}
								>
									{option.label}
								</option>
							))}
						</TextField>
					</Grid>
					<Grid item>
						<TextField
							id="standard-select-currency"
							select
							label="Select"
							defaultValue="EUR"
							helperText="Please select your currency"
							variant="standard"
						>
							{currencies.map((option) => (
								<MenuItem
									key={option.value}
									value={option.value}
								>
									{option.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
					<Grid item>
						<TextField
							id="standard-select-currency-native"
							select
							label="Native select"
							defaultValue="EUR"
							SelectProps={{
								native: true,
							}}
							helperText="Please select your currency"
							variant="standard"
						>
							{currencies.map((option) => (
								<option
									key={option.value}
									value={option.value}
								>
									{option.label}
								</option>
							))}
						</TextField>
					</Grid>
				</Grid>
			</Box>*/}
			
			<h3>
				AUTOCOMPLETE -----------------------------------------------------------------------------
			</h3>
			<Autocompletes
				top100Films={top100Films}
				defaultProps={defaultProps}
				flatProps={flatProps}
			/>
			
			<h3>
				DATE TIME PICKERS -----------------------------------------------------------------------------
			</h3>
			<DateTimePickers/>
			
			<h3>
				CHECKBOX -----------------------------------------------------------------------------
			</h3>
			<Checkboxes
				gilad={gilad}
				handleChange={handleChange}
				jason={jason}
				antoine={antoine}
				error={error}
			/>
			
			<h3>
				RADIO -----------------------------------------------------------------------------
			</h3>
			<RadioButtons/>
			
			
			<h3>
				RATING -----------------------------------------------------------------------------
			</h3>
			<Ratings/>
			
			<h3>
				SWITCH -----------------------------------------------------------------------------
			</h3>
			<Switches label={label}/>
			
			<h3>
				SLIDER -----------------------------------------------------------------------------
			</h3>
			<Sliders/>
			
			<h3>
				TOGGLE BUTTON -----------------------------------------------------------------------------
			</h3>
			<ToggleButtons alignment={alignment} handleAlignment={handleAlignment}/>
		
		</div>
	)
}

export default Inputs